import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import '../../../libs/bulma.min.css';
import PbxContext from '../../../context/PbxContext';
import { accessLocalStorage, exportSelectTrunkById, exportDeleteTrunks, changeViewForms, sendRegisterTrunkSystem } from '../../../services';
import Loading from '../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faStop, faPlay } from '@fortawesome/free-solid-svg-icons';

function EndpointsListById() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [phones, setPhones] = useState([]);
  const [trunksSelected, setTrunksSelected] = useState([]);
  const [disable, setDisable] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [typeRegistry, setTypeRegistry] = useState('unregister');
  const [message, setMessage] = useState('');

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const history = useHistory();

  const fetchTrunks = async () => {
    
    const trunkReceived = await exportSelectTrunkById({ elements: itemsSelectedToEdit.toString() });

    if(trunkReceived <= 0) return history.push('/config/tronco/lista');
    if(trunkReceived === undefined) return setLoading(true);

    const elements = trunkReceived.map((element) => {
      const result = {
        serverIP: element.serverIP.includes('@') ? element.serverIP.split(':')[1].split('@')[1] : element.serverIP.split(':')[1],
        localIP:  element.localIP.includes('@') ? element.localIP.split(':')[1].split('@')[1] : element.localIP.split(':')[1],
        nameuser: element.nameuser === null ? '' : element.nameuser,
        pass: element.pass === null ? '' : element.pass,
      };
      result.name = element.name;
      result.trunk = element.trunk;
      result.codec = element.codec;

      return result;
    });

    setPhones(elements);
    setLoading(false);
    return true;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    const elements = await fetchTrunks();
    return;
  }, []);

  const handleChangeSelectedTrunks = (element) => {
    setTrunksSelected((prevState) => {
      const onlineState = prevState.includes(element) ? [...prevState.filter((e) => e !== element)] : [...prevState, element];
      onlineState.length > 0 ? setDisable(false) : setDisable(true)
      return onlineState;
    });
  };
  
  const handleSendRegisterTrunk = async () => {
    setIsPlaying(isPlaying ? false : true)
    setTypeRegistry((prevState) => {
      const type = prevState === 'unregister' ?  'register' : 'unregister'
      return type;
    });
    const result = await sendRegisterTrunkSystem({ type: typeRegistry, trunk: trunksSelected[0] });
    if (result.status !== 200) toggleIsHidden('#alert-registry-send');
  };

  const handleClickDelete = async () => {
    const sendDeleteTrunks = await exportDeleteTrunks(trunksSelected);
    if(sendDeleteTrunks.length === undefined) {
      toggleIsHidden('#alert-confirm-trunks-delete');
      return toggleIsChangeFormElements('alert-trunks-not-delete', 'column is-half is-offset-one-quarter message is-danger is-active');
    };
    toggleIsHidden('#alert-confirm-trunks-delete');
    setDisable(true);
    toggleIsHidden('#buttons');
    validateUserLogged();
    return;
  };

  useEffect(() => {
    validateUserLogged()
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div className="mt-4">
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">TRONCOS</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-trunks-not-delete" name="alert-trunks-not-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-trunks-not-delete') }></button>
            </div>
            <div className="message-body">
              Não foi possível deletar o(s) troncos selecionados.
            </div>
          </article>
          <article id="alert-endpoints-not-selected" name="alert-endpoints-not-selected" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-endpoints-not-selected') }></button>
            </div>
            <div className="message-body">
              Nenhum tronco selecionado!
            </div>
          </article>
          <article id="alert-create-endpoints" name="alert-create-endpoints" className="column is-half is-offset-one-quarter message is-warning is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-create-endpoints') }></button>
            </div>
            <div className="message-body">
              Tronco(s) deletado(s) com sucesso!
            </div>
          </article>
          <article id="alert-confirm-trunks-delete" name="alert-confirm-trunks-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-confirm-trunks-delete') }></button>
            </div>
            <div className="message-body">
              Tem certeza que quer deletar o(s) tronco(s) selecionados?
            </div>
            <br />
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered is-active">
              <button className="button is-danger is-half mx-3 px-5" type="submit" onClick={ () => handleClickDelete() }>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faTrash } fixedWidth />
                    </span>
                    <span>
                      Confirmar
                    </span>
              </button>
              <button className="button is-info is-half mx-3 px-5" type="submit" onClick={ () => {
                toggleIsHidden('#alert-confirm-trunks-delete')
                toggleIsHidden('#buttons')
              }}>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faTrash } fixedWidth />
                    </span>
                    <span>
                      Cancelar
                    </span>
              </button>
            </div>
          </div>
          </article>
          <article id="alert-create-endpoints" name="alert-create-endpoints" className="column is-half is-offset-one-quarter message is-warning is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-create-endpoints') }></button>
            </div>
            <div className="message-body">
              Tronco(s) deletados com sucesso!
            </div>
          </article>
          <div className="table-container is-flex-wrap-wrap has-text-centered">
            <table id="tableCalls" className="table column is-hoverable is-striped is-bordered is-fullwhidth is-offset-3">  
                <thead>
                    <tr className='is-size-6 has-text-centered has-background-link-light'>
                  <th className='th-interactive is-clickable ' scope="col">
                    {/* <input id="select-all"type="checkbox" onClick={ () => handleChangeSelectAll()}/> */}
                    Sel.
                  </th>
                    <th className='th-interactive is-clickable' scope="col">Nome</th>
                    <th className='th-interactive is-clickable' scope="col">IP Local</th>
                    <th className='th-interactive is-clickable' scope="col">IP Remoto</th>
                    <th className='th-interactive is-clickable' scope="col">Tronco</th>
                    <th className='th-interactive is-clickable' scope="col">Codec</th>
                    <th className='th-interactive is-clickable' scope="col">Usuário</th>
                    <th className='th-interactive is-clickable' scope="col">Senha</th>
                    <th className='th-interactive is-clickable' scope="col">Funcionalidades</th>
                    </tr>
                </thead>
                <tbody>
                {
                  phones.map((phone) => {
                    const { name, localIP, serverIP, trunk, codec, nameuser, pass } = phone;
                    return (
                      <tr  key={ name } className='is-size-6 has-text-centered'>
                        <td><input name="selectTrunk" id={ name } type="radio" value={name} onClick={ (e) => handleChangeSelectedTrunks(e.target.value)}/></td>
                        <td>{name}</td>
                        <td>{localIP}</td>
                        <td>{serverIP}</td>
                        <td>{trunk}</td>
                        <td className="is-uppercase">{codec}</td>
                        <td>{ !nameuser ? 'N/A' : nameuser }</td>
                        <td>{ !pass ? 'N/A' : pass }</td>
                        <td className="border p-2 space-x-2 is-family-monospace">
                          <button
                            className="button is-danger is-small mx-1 px-3"
                            onClick={ () => {
                              toggleIsHidden('#alert-confirm-trunks-delete')
                              toggleIsHidden('#buttons')
                              }}
                            disabled={ disable }
                          >
                            <span className="icon">
                              <FontAwesomeIcon icon={faTrash} fixedWidth />
                            </span>
                          </button>
                          <button
                            className="button is-success is-small mx-1 px-3"
                            onClick={() => handleSendRegisterTrunk()}
                            disabled={ disable }
                          >
                            {isPlaying ? (
                              <span className="icon">
                                <FontAwesomeIcon icon={faStop} fixedWidth />
                              </span>
                            ) : (
                              <span className="icon">
                                <FontAwesomeIcon icon={faPlay} fixedWidth />
                              </span>
                            )}
                          </button>
                        </td>
                      </tr>
                    )
                  })
                }
                </tbody>
            </table>
            <article id="alert-registry-send" name="alert-registry-send" className="column is-half is-offset-one-quarter message is-warming has-text-centered is-hidden">
              <div className="message-header has-text-centered is-fullwidth">
                <p className="has-text-centered is-fullwidth">Mensagem</p>
                <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-registry-send') }></button>
              </div>
              <div className="message-body">
                Não foi possivel enviar o registro do tronco {trunksSelected}!
              </div>
            </article>
          </div>
          {/* <div className="columns">
            <div id="buttons" className="column is-half is-offset-one-quarter has-text-centered is-active">
                <button
                  className="button is-danger is-half mx-3 px-6"
                  type="submit"
                  onClick={ () => {
                    toggleIsHidden('#alert-confirm-trunks-delete')
                    toggleIsHidden('#buttons')
                    }}
                  disabled={ disable }
                >
                      <span className="icon">
                        <FontAwesomeIcon icon={ faTrash } fixedWidth />
                      </span>
                      <span>
                        Deletar
                      </span>
                </button>
            </div>
          </div> */}
        </div>
      }
    </div>
  );
}

export default EndpointsListById;
